// File types that can be embedded in emails using CID tags
export const embeddableFileType = fileType => {
  if (fileType.match(/^audio/)) return true
  if (fileType.match(/^image/)) return true

  return false
}
